/**
 * CM > IPS > 침입탐지 프로파일 > 시그니처 사용자 정의
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {i18n} from '~/plugins/i18n'
import {SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix} from '~/utils/restApi'
import {arraysIntoObject} from '~/utils/common'

class ProfileData {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_prf_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_prf_id')) this.modelType = 'ads'
    else this.modelType = modelType

    this.prf_id = this.getValue(obj, ['ngips_prf_id', 'ads_ips_prf_id'], 'prf_id')
    this.prf_name = this.getValue(obj, ['ngips_prf_name', 'ads_ips_prf_name'], 'prf_name')
    this.prf_desc = this.getValue(obj, ['ads_ips_prf_desc', 'ngips_prf_desc'], 'prf_desc')
    this.prf_use_yn = this.getValue(obj, ['ngips_prf_use_yn', 'ads_ips_prf_use_yn'], 'prf_use_yn')
    this.prf_direct = this.getValue(obj, ['ngips_prf_direct', 'ads_ips_prf_direct'], 'prf_direct')
    this.base_signtr_tmplt_id = this.getValue(obj, ['ngips_prf_base_signtr_tmplt_id', 'base_signtr_tmplt_id'], 'base_signtr_tmplt_id')
    this.prtect_rqst_level_id = this.getValue(obj, ['ngips_prf_prtect_rqst_level_id', 'prtect_rqst_level_id'], 'prtect_rqst_level_id')
    this.pd_use_yn = this.getValue(obj, ['pd_use_yn', 'pd_use_yn'], 'pd_use_yn')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  formApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

class PolicyData {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_signtr_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_signtr_id')) this.modelType = 'ads'
    else this.modelType = modelType
    // this.signtr_opt_cfg_status = this.getValue(obj, ['ngips_signtr_opt_cfg_status'], 'signtr_opt_cfg_status')
    this.prf_id = this.getValue(obj, ['ngips_prf_id', 'ads_ips_prf_id'], 'prf_id')
    this.signtr_opt_use_yn = this.getValue(obj, ['ngips_signtr_opt_use_yn', 'ads_ips_signtr_opt_use_yn'], 'signtr_opt_use_yn')
    this.signtr_cate = this.getValue(obj, ['ngips_signtr_cate', 'ads_ips_signtr_cate'], 'signtr_cate')
    this.signtr_id = this.getValue(obj, ['ngips_signtr_id', 'ads_ips_signtr_id'], 'signtr_id')
    this.signtr_msg = this.getValue(obj, ['ngips_signtr_msg', 'ads_ips_signtr_msg'], 'signtr_msg')
    this.signtr_opt_action = this.getValue(obj, ['ngips_signtr_opt_action', 'ads_ips_signtr_opt_action'], 'signtr_opt_action')
    this.signtr_opt_block_key = this.getValue(obj, ['ngips_signtr_opt_block_key', 'ads_ips_signtr_opt_block_key'], 'signtr_opt_block_key')
    this.signtr_opt_block_tm = this.getValue(obj, ['ngips_signtr_opt_block_tm', 'ads_ips_signtr_opt_block_tm'], 'signtr_opt_block_tm')
    this.signtr_opt_msg = this.getValue(obj, ['ngips_signtr_opt_msg', 'ads_ips_signtr_opt_msg'], 'signtr_opt_msg')
    this.signtr_opt_msg_org = this.getValue(obj, ['ngips_signtr_opt_msg_org', 'ads_ips_signtr_opt_msg_org'], 'signtr_opt_msg_org')
    this.signtr_risk = this.getValue(obj, ['ngips_signtr_risk', 'ads_ips_signtr_risk'], 'signtr_risk')
    this.signtr_effect = this.getValue(obj, ['ngips_signtr_effect', 'ads_ips_signtr_effect'], 'signtr_effect')
    this.signtr_ckc_id = this.getValue(obj, ['ngips_signtr_ckc_id', 'ads_ips_signtr_ckc_id'], 'signtr_ckc_id')
    this.signtr_prtc = this.getValue(obj, ['ngips_signtr_prtc', 'ads_ips_signtr_prtc'], 'signtr_prtc')
    this.category_cate_name = this.getValue(obj, ['ngips_category_cate_name', 'ads_ips_category_name'], 'category_cate_name')
    this.signtr_port_port_src_port = this.getValue(obj, ['ngips_signtr_port_port_src_port', 'ads_ips_signtr_port_port_src_port'], 'signtr_port_port_src_port')
    this.signtr_port_port_dst_port = this.getValue(obj, ['ngips_signtr_port_port_dst_port', 'ads_ips_signtr_port_port_dst_port'], 'signtr_port_port_dst_port')
    this.signtr_opt_direction = this.getValue(obj, ['ngips_signtr_opt_direction', 'ads_ips_signtr_opt_direction'], 'signtr_opt_direction')
    this.signtr_opt_log_use_yn = this.getValue(obj, ['ngips_signtr_opt_log_use_yn', 'ads_ips_signtr_opt_log_use_yn'], 'signtr_opt_log_use_yn')
    this.signtr_opt_dump_use_yn = this.getValue(obj, ['ngips_signtr_opt_dump_use_yn', 'ads_ips_signtr_opt_dump_use_yn'], 'signtr_opt_dump_use_yn')
    this.signtr_opt_mail_use_yn = this.getValue(obj, ['ngips_signtr_opt_mail_use_yn', 'ads_ips_signtr_opt_mail_use_yn'], 'signtr_opt_mail_use_yn')
    this.signtr_opt_alert_use_yn = this.getValue(obj, ['ngips_signtr_opt_alert_use_yn', 'ads_ips_signtr_opt_alert_use_yn'], 'signtr_opt_alert_use_yn')
    this.signtr_opt_alarm_use_yn = this.getValue(obj, ['ngips_signtr_opt_alarm_use_yn', 'ads_ips_signtr_opt_alarm_use_yn'], 'signtr_opt_alarm_use_yn')
    this.signtr_attacker = this.getValue(obj, ['ngips_signer_attacker', 'ads_ips_signtr_attacker'], 'signtr_attacker')
    this.signtr_threat_id = this.getValue(obj, ['ngips_signtr_threat_id', 'ads_ips_signtr_threat_id'], 'signtr_threat_id')
    this.cfg_layer = this.getValue(obj, ['cfg_layer', 'cfg_layer'], 'cfg_layer')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  formApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
  fromAddForm () {
    const addFormKey = [
      'prf_id', 'signtr_id', 'signtr_opt_use_yn', 'signtr_opt_action', 'signtr_opt_block_key',
      'signtr_opt_block_tm', 'signtr_opt_log_use_yn', 'signtr_opt_dump_use_yn', 'signtr_opt_mail_use_yn',
      'signtr_opt_alert_use_yn', 'signtr_opt_alarm_use_yn', 'signtr_opt_direction'
    ]
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      if (addFormKey.includes(key)) ret[orgKey] = this[key]
    })
    return ret
  }
}

class ExceptHostAddForm {
  constructor (obj, modelType = 'ips') {
    this.prf_id = obj.prf_id
    this.modelType = modelType
    this.excpt_host_desc = obj.excpt_host_desc // desc
    this.excpt_list = _.cloneDeep(obj.excpt_list) // 출발지, 목적지
    this.policy_list = _.cloneDeep(obj.policy_list)
  }
  formApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_prf_id: this.prf_id,
        ngips_signtr_excpt_host_desc: this.excpt_host_desc,
        ngips_signtr_excpt_list: _.map(this.excpt_list, o => {
          return {
            ngips_signtr_excpt_host_src_addr_obj_id: o.src_addr_obj_id,
            ngips_signtr_excpt_host_dst_addr_obj_id: o.dst_addr_obj_id
          }
        }),
        ngips_signtr_list: this.policy_list
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_ips_prf_id: this.prf_id,
        ads_ips_signtr_excpt_host_desc: this.excpt_host_desc,
        ads_ips_signtr_excpt_list: this.excpt_list,
        ads_ips_signtr_list: this.policy_list
      }
    }
    return {}
  }
}

class ExceptHostGetForm {
  constructor (obj) {
    // ips
    if (_.has(obj, 'ngips_signtr_opt_msg')) {
      this.policy_exc_desc = obj.ngips_signtr_opt_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.ngips_signtr_excpt_host_src_addr_obj_id,
          src_ip_ver: o.ngips_signtr_excpt_host_src_ip_ver_type,
          src_name: o.ngips_signtr_excpt_host_src_obj_uname,
          src_type: o.ngips_signtr_excpt_host_src_obj_type,
          dst_addr_obj_id: o.ngips_signtr_excpt_host_dst_addr_obj_id,
          dst_ip_ver: o.ngips_signtr_excpt_host_dst_ip_ver_type,
          dst_name: o.ngips_signtr_excpt_host_dst_obj_uname,
          dst_type: o.ngips_signtr_excpt_host_dst_obj_type
        }
      })
    }
    // ads
    if (_.has(obj, 'ads_ips_signtr_opt_msg')) {
      this.policy_exc_desc = obj.ads_ips_signtr_opt_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.src_addr_obj_id,
          src_ip_ver: o.src_ip_ver_type,
          src_name: o.src_obj_uname,
          src_type: o.src_obj_type,
          dst_addr_obj_id: o.dst_addr_obj_id,
          dst_ip_ver: o.dst_ip_ver_type,
          dst_name: o.dst_obj_uname,
          dst_type: o.dst_obj_type
        }
      })
    }
  }
}

class PolicyAllForm {
  constructor (obj, modelType) {
    if (modelType === 'ips') {
      this.edit_item = `ngips_${obj.edit_item}`
      this.edit_item_value = obj.edit_item_value
      this.ngips_signtr_list = obj.signtr_list
    } else if (modelType === 'ads') {
      this.edit_item = `ads_ips_${obj.edit_item}`
      this.edit_item_value = obj.edit_item_value
      this.ads_ips_signtr_list = obj.signtr_list
    }
  }
}

class SignatureData {
  constructor (obj, modelType) {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_signtr_opt_use_yn')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_signtr_opt_use_yn')) this.modelType = 'ads'
    else this.modelType = modelType
    this.signtr_opt_use_yn = this.__getValue(obj, ['ngips_signtr_opt_use_yn', 'ads_ips_signtr_opt_use_yn'], 'signtr_opt_use_yn')
    this.signtr_cate = this.__getValue(obj, ['ngips_signtr_cate', 'ads_ips_signtr_cate'], 'signtr_cate')
    this.signtr_type = this.__getValue(obj, ['ngips_signtr_type', 'ads_ips_signtr_type'], 'signtr_type')
    this.signtr_prtc = this.__getValue(obj, ['ngips_signtr_prtc', 'ads_ips_signtr_prtc'], 'signtr_prtc')
    this.signtr_msg = this.__getValue(obj, ['ngips_signtr_msg', 'ads_ips_signtr_msg'], 'signtr_msg')
    this.signtr_risk = this.__getValue(obj, ['ngips_signtr_risk', 'ads_ips_signtr_risk'], 'signtr_risk')
    this.signtr_effect = this.__getValue(obj, ['ngips_signtr_effect', 'ads_ips_signtr_effect'], 'signtr_effect')
    this.signtr_ckc_id = this.__getValue(obj, ['ngips_signtr_ckc_id', 'ads_ips_signtr_ckc_id'], 'signtr_ckc_id')
    this.signtr_threat_id = this.__getValue(obj, ['ngips_signtr_threat_id', 'ads_ips_signtr_threat_id'], 'signtr_threat_id')
    this.signtr_kr_desc = this.__getValue(obj, ['ngips_signtr_kr_desc', 'ads_ips_signtr_kr_desc'], 'signtr_kr_desc')
    this.signtr_en_desc = this.__getValue(obj, ['ngips_signtr_en_desc', 'ads_ips_signtr_en_desc'], 'signtr_en_desc')
    this.signtr_jp_desc = this.__getValue(obj, ['ngips_signtr_jp_desc', 'ads_ips_signtr_jp_desc'], 'signtr_jp_desc')
    this.signtr_ptrn = this.__getValue(obj, ['ngips_signtr_ptrn', 'ads_ips_signtr_ptrn'], 'signtr_ptrn')
    this.signtr_opt_action = this.__getValue(obj, ['ngips_signtr_opt_action', 'ads_ips_signtr_opt_action'], 'signtr_opt_action')
    this.signtr_opt_block_key = this.__getValue(obj, ['ngips_signtr_opt_block_key', 'ads_ips_signtr_opt_block_key'], 'signtr_opt_block_key')
    this.signtr_opt_block_tm = this.__getValue(obj, ['ngips_signtr_opt_block_tm', 'ads_ips_signtr_opt_block_tm'], 'signtr_opt_block_tm')
    this.signtr_opt_log_use_yn = this.__getValue(obj, ['ngips_signtr_opt_log_use_yn', 'ads_ips_signtr_opt_log_use_yn'], 'signtr_opt_log_use_yn')
    this.signtr_opt_dump_use_yn = this.__getValue(obj, ['ngips_signtr_opt_dump_use_yn', 'ads_ips_signtr_opt_dump_use_yn'], 'signtr_opt_dump_use_yn')
    this.signtr_opt_mail_use_yn = this.__getValue(obj, ['ngips_signtr_opt_mail_use_yn', 'ads_ips_signtr_opt_mail_use_yn'], 'signtr_opt_mail_use_yn')
    this.signtr_opt_alert_use_yn = this.__getValue(obj, ['ngips_signtr_opt_alert_use_yn', 'ads_ips_signtr_opt_alert_use_yn'], 'signtr_opt_alert_use_yn')
    this.signtr_opt_msg = this.__getValue(obj, ['ngips_signtr_opt_msg', 'ads_ips_signtr_opt_msg'], 'signtr_opt_msg')
    this.signtr_port_port_src_port = this.__getValue(obj, ['ngips_signtr_port_port_src_port', 'ads_ips_signtr_port_port_src_port'], 'signtr_port_port_src_port')
    this.signtr_port_port_dst_port = this.__getValue(obj, ['ngips_signtr_port_port_dst_port', 'ads_ips_signtr_port_port_dst_port'], 'signtr_port_port_dst_port')
    this.signtr_opt_direction = this.__getValue(obj, ['ngips_signtr_opt_direction', 'ads_ips_signtr_opt_direction'], 'signtr_opt_direction')
    this.usr_def_signtr_obj = this.__getSigSetObj(obj, this.modelType === 'ips' ? 'ngips_usr_def_signtr_obj' : 'ads_ips_usr_def_signtr_obj')
    this.signtr_src_addr_obj = this.__getAddrObj(obj, this.modelType === 'ips' ? 'ngips_signtr_src_addr_obj' : 'ads_ips_signtr_src_addr_obj', 'signtr_src_addr_obj')
    this.signtr_dst_addr_obj = this.__getAddrObj(obj, this.modelType === 'ips' ? 'ngips_signtr_dst_addr_obj' : 'ads_ips_signtr_dst_addr_obj', 'signtr_dst_addr_obj')
    this.snort_signature = this.__getValue(obj, ['snort_signature', 'snort_signature'], 'snort_signature')
    this.profile_list = this.__getValue(obj, ['ngips_profile_list', 'ads_ips_profile_list'], 'profile_list')
  }
  __getVal (obj, keys) {
    return _.cloneDeep(_.get(_.values(_.pick(obj, keys)), 0, void 0))
  }
  // 고급 설정 주입
  __getSigSetObj (obj, orgKey) {
    this.keyList.push('usr_def_signtr_obj')
    this.orgKeyList.push(orgKey)
    const configDataList = this.__getVal(obj, [orgKey, 'usr_def_signtr_obj'])
    return _.map(configDataList, o => {
      return {
        usr_def_signtr_type: this.__getVal(o, ['ngips_usr_def_signtr_type', 'ads_ips_usr_def_signtr_type', 'usr_def_signtr_type']),
        usr_def_signtr_nocase_use: this.__getVal(o, ['ngips_usr_def_signtr_nocase_use', 'ads_ips_usr_def_signtr_nocase_use', 'usr_def_signtr_nocase_use']),
        usr_def_signtr_prtn: this.__getVal(o, ['ngips_usr_def_signtr_prtn', 'ads_ips_usr_def_signtr_prtn', 'usr_def_signtr_prtn']),
        usr_def_signtr_offset: this.__getVal(o, ['ngips_usr_def_signtr_offset', 'ads_ips_usr_def_signtr_offset', 'usr_def_signtr_offset']),
        usr_def_signtr_depth: this.__getVal(o, ['ngips_usr_def_signtr_depth', 'ads_ips_usr_def_signtr_depth', 'usr_def_signtr_depth']),
        usr_def_signtr_distance: this.__getVal(o, ['ngips_usr_def_signtr_distance', 'ads_ips_usr_def_signtr_distance', 'usr_def_signtr_distance']),
        usr_def_signtr_within: this.__getVal(o, ['ngips_usr_def_signtr_within', 'ads_ips_usr_def_signtr_within', 'usr_def_signtr_within'])
      }
    })
  }
  // 출발지/목적지 주소 객체 주입
  __getAddrObj (obj, orgKey, key) {
    this.keyList.push(key)
    this.orgKeyList.push(orgKey)
    const addrObjList = _.cloneDeep(_.get(_.values(_.pick(obj, [orgKey, key])), 0, void 0))
    return _.map(addrObjList, o => {
      return {
        signtr_addr_obj_ref_addr_obj_id: _.cloneDeep(_.get(_.values(_.pick(o, ['ngips_signtr_addr_obj_ref_addr_obj_id', 'ads_ips_addr_obj_id', 'signtr_addr_obj_ref_addr_obj_id'])), 0, void 0)),
        addr_obj_uname: o.addr_obj_uname,
        addr_obj_ip_ver_type: o.addr_obj_ip_ver_type,
        addr_obj_type: o.addr_obj_type,
        addr_obj_ip_start_ip: o.addr_obj_ip_start_ip,
        addr_obj_ip_mask: o.addr_obj_ip_mask
      }
    })
  }
  // 값 주입
  __getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(_.get(_.keys(_.pick(obj, [...arr])), 0, this.modelType === 'ips' ? arr[0] : arr[1]))
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  formApiParam () {
    if (!this.modelType) console.warn('not found modelType')
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      if (['signtr_src_addr_obj', 'signtr_dst_addr_obj'].includes(key)) {
        ret[orgKey] = _.map(this[key], o => {
          if (this.modelType === 'ips') return {ngips_signtr_addr_obj_ref_addr_obj_id: o.signtr_addr_obj_ref_addr_obj_id}
          if (this.modelType === 'ads') return {ads_ips_addr_obj_id: o.signtr_addr_obj_ref_addr_obj_id}
          return {}
        })
      } else if (key === 'usr_def_signtr_obj') {
        ret[orgKey] = _.map(this[key], o => {
          if (this.modelType === 'ips') {
            return {
              ngips_usr_def_signtr_type: o.usr_def_signtr_type,
              ngips_usr_def_signtr_nocase_use: o.usr_def_signtr_nocase_use,
              ngips_usr_def_signtr_prtn: o.usr_def_signtr_prtn,
              ngips_usr_def_signtr_offset: o.usr_def_signtr_offset,
              ngips_usr_def_signtr_depth: o.usr_def_signtr_depth,
              ngips_usr_def_signtr_distance: o.usr_def_signtr_distance,
              ngips_usr_def_signtr_within: o.usr_def_signtr_within
            }
          }
          if (this.modelType === 'ads') {
            return {
              ads_ips_usr_def_signtr_type: o.usr_def_signtr_type,
              ads_ips_usr_def_signtr_nocase_use: o.usr_def_signtr_nocase_use,
              ads_ips_usr_def_signtr_prtn: o.usr_def_signtr_prtn,
              ads_ips_usr_def_signtr_offset: o.usr_def_signtr_offset,
              ads_ips_usr_def_signtr_depth: o.usr_def_signtr_depth,
              ads_ips_usr_def_signtr_distance: o.usr_def_signtr_distance,
              ads_ips_usr_def_signtr_within: o.usr_def_signtr_within
            }
          }
          return {}
        })
      } else {
        ret[orgKey] = this[key]
      }
    })
    return ret
  }
}

class OtherProfileApplyForm {
  constructor (obj, modelType) {
    if (modelType === 'ips') {
      this.ngips_profile_list = obj.profile_list
      this.ngips_signtr_items = _.mapKeys(obj.signtr_items, (val, key) => {
        return `ngips_${key}`
      })
    }
    if (modelType === 'ads') {
      this.ads_ips_profile_list = obj.profile_list
      this.ads_ips_signtr_items = _.mapKeys(obj.signtr_items, (val, key) => {
        return `ads_ips_${key}`
      })
    }
  }
}

class CategoryFilterData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_category_cate_code')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_category_code')) this.modelType = 'ads'
    this.category_cate_code = this.__getValue(obj, ['ngips_category_cate_code', 'ads_ips_category_code'], 'category_cate_code')
    this.category_cate_name = this.__getValue(obj, ['ads_ips_category_name', 'ngips_category_cate_name'], 'category_cate_name')
    this.category_i_cate_code = this.__getValue(obj, ['ads_ips_category_i_code', 'ngips_category_i_cate_code'], 'category_i_cate_code')
    this.category_release_type = this.__getValue(obj, ['ads_ips_category_release_type', 'ngips_category_release_type'], 'category_release_type')
  }
  __getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
}

export const state = () => ({
  userDefineInfo: {
    fieldData: {
      signtr_opt_use_yn: 1, // 사용여부
      signtr_cate: 0, // 사용자 정의 0 / 스노트 1
      signtr_type: 0, // 유형 없음: 0, 수동설정: 1, 고급설정: 2, snort시그니처: 3
      signtr_prtc: 3, // 프로토콜 IP: 0, ICMP: 1, TCP: 2, UDP: 3
      signtr_msg: '', // 정책 이름
      signtr_risk: 1, // 위험도 하: 1, 중: 2, 상: 3
      signtr_effect: 1, // 성능 영향도 하: 1, 중: 2, 상: 3
      signtr_ckc_id: 0,
      signtr_threat_id: 1035,
      signtr_kr_desc: '',
      signtr_en_desc: '',
      signtr_jp_desc: '',
      signtr_ptrn: '', // 패턴
      signtr_opt_action: 0, // 대응 탐지: 0, 패킷 차단: 1, IP 주소 차단: 2, 패킷 차단/Reset: 3, IP 주소 차단/Reset: 4
      signtr_opt_block_key: 5,
      signtr_opt_block_tm: 180, // 차단 시간 ( - default:180 - minimum: 10 - maximum: 3600 or 0)
      signtr_opt_log_use_yn: 1,
      signtr_opt_dump_use_yn: 0,
      signtr_opt_mail_use_yn: 0,
      signtr_opt_alert_use_yn: 0,
      signtr_opt_msg: '',
      signtr_port_port_src_port: 'any', // 출발지 포트
      signtr_port_port_dst_port: 'any', // 목적지 포트
      signtr_opt_direction: 0, // 방향
      usr_def_signtr_obj: [],
      signtr_src_addr_obj: [
        {
          addr_obj_id: 1, // 주소 객체 아이디
          addr_obj_uname: 'ANY' // 이름
        }
      ],
      // dst_addr_obj: [
      signtr_dst_addr_obj: [
        {
          addr_obj_id: 1,
          addr_obj_uname: 'ANY'
        }
      ]
    }
  },
  signatureCategory: [],
  signatureUsrDefList: [],
  orgSignatureUsrDefList: []
})

export const getters = {
  /**
   * 시그니처 카테고리를 필터로 매핑한다.
   */
  getSignCateUserDefOptions (state) {
    return state.signatureCategory.map(cate => ({
      key: cate.category_cate_code,
      value: cate.category_cate_name,
      label: cate.category_cate_name
    })) || []
  }
}

export const mutations = {
  initStore (state) {
    state.userDefineInfo.fieldData = {
      signtr_opt_use_yn: 1, // 사용여부
      signtr_cate: 0, // 사용자 정의 0 / 스노트 1
      signtr_type: 0, // 유형 없음: 0, 수동설정: 1, 고급설정: 2, snort시그니처: 3
      signtr_prtc: 3, // 프로토콜 IP: 0, ICMP: 1, TCP: 2, UDP: 3
      signtr_msg: '', // 정책 이름
      signtr_risk: 1, // 위험도 하: 1, 중: 2, 상: 3
      signtr_effect: 1, // 성능 영향도 하: 1, 중: 2, 상: 3
      signtr_ckc_id: 0,
      signtr_threat_id: 1035,
      signtr_kr_desc: '',
      signtr_en_desc: '',
      signtr_jp_desc: '',
      signtr_ptrn: '', // 패턴
      signtr_opt_action: 0, // 대응 탐지: 0, 패킷 차단: 1, IP 주소 차단: 2, 패킷 차단/Reset: 3, IP 주소 차단/Reset: 4
      signtr_opt_block_key: 5,
      signtr_opt_block_tm: 180, // 차단 시간 ( - default:180 - minimum: 10 - maximum: 3600 or 0)
      signtr_opt_log_use_yn: 1,
      signtr_opt_dump_use_yn: 0,
      signtr_opt_mail_use_yn: 0,
      signtr_opt_alert_use_yn: 0,
      signtr_opt_msg: '',
      signtr_port_port_src_port: 'any', // 출발지 포트
      signtr_port_port_dst_port: 'any', // 목적지 포트
      signtr_opt_direction: 0, // 방향
      usr_def_signtr_obj: [],
      signtr_src_addr_obj: [
        {
          addr_obj_id: 1, // 주소 객체 아이디
          addr_obj_uname: 'ANY' // 이름
        }
      ],
      signtr_dst_addr_obj: [
        {
          addr_obj_id: 1,
          addr_obj_uname: 'ANY'
        }
      ]
    }
    state.signatureCategory = []
    state.signatureUsrDefList = []
    state.orgSignatureUsrDefList = []
  },
  /* 전달된 사용자 정의 시그니처 정책을 스토어에 추가한다. (GUI 갱신 안됨 주의) */
  addSignatureItem (state, policy) {
    const newSignatureList = _.cloneDeep(state.signatureUsrDefList)

    if (_.isArray(policy)) {
      for (const newPolicy of policy) {
        newSignatureList.push(new PolicyData(newPolicy).get())
      }
    } else {
      newSignatureList.push(new PolicyData(policy).get())
    }

    state.signatureUsrDefList = Object.freeze(newSignatureList)
    state.orgSignatureUsrDefList = _.cloneDeep(state.signatureUsrDefList)
  },
  /* 전달된 시그니처 사용자 정의 정책 ID를 찾아 스토어에 반영한다. (테이블 데이터 수정 후 처리) */
  setSignatureItem (state, policy) {
    const idx = state.signatureUsrDefList.findIndex(({signtr_id: id}) => id === policy.signtr_id)

    if (idx > -1) {
      const copy = _.cloneDeep(state.signatureUsrDefList)
      copy[idx] = policy

      state.signatureUsrDefList = Object.freeze(copy)
    }
  },
  /* 전달된 시그니처 사용자 정의 정책 ID를 찾아 스토어에 반영한다. (테이블 데이터 수정 후 처리) */
  setSignatureItems (state, rules) {
    const copy = _.cloneDeep(state.signatureUsrDefList)
    _.forEach(rules, (policy) => {
      const idx = state.signatureUsrDefList.findIndex(({signtr_id: id}) => id === policy.signtr_id)
      if (idx > -1) copy[idx] = policy
    })
    state.signatureUsrDefList = Object.freeze(copy)
  },
  /* 예외호스트를 저장한다. */
  setHostItems (state, rules) {
    const copy = _.cloneDeep(state.signatureUsrDefList)
    rules = _.map(rules, o => new PolicyData(o).get())
    _.forEach(rules, (policy) => {
      const idx = state.signatureUsrDefList.findIndex(({signtr_id: id}) => id === policy.signtr_id)
      if (idx > -1) copy[idx].signtr_opt_msg = policy.signtr_opt_msg
    })
    state.signatureUsrDefList = Object.freeze(copy)
  },
  setSignatureUsrDefList (state, rules) {
    state.signatureUsrDefList = Object.freeze(_.cloneDeep(rules))
  },
  /* 시그니처 카테고리를 스토어에 초기화한다. 사용자 정의는 release_type > 0으로 설정 */
  setSignatureCategory (state, category) {
    const categoryDataList = _.map(category, o => new CategoryFilterData(o).get())
    const ruleCategory = categoryDataList.filter(item => item.category_release_type === 0) || []
    state.signatureCategory = Object.freeze(ruleCategory)
  },
  /* 시그니처 사용자 정의 목록을 초기화한다. */
  initSignatureUsrDefList (state, payload) {
    const list = arraysIntoObject(payload.signtr_column_name, payload.signtr_list)
    state.signatureUsrDefList = Object.freeze(_.map(list, o => new PolicyData(o).get()))
    state.orgSignatureUsrDefList = _.cloneDeep(state.signatureUsrDefList)
  },
  /* 선택된 시그니처 사용자 정의 정책을 수정할 때, 팝업과 연결되어 있는 스토어의 데이터를 초기화한다. */
  setDetailSignatureUsrDef (state, policy) {
    const keys = Object.keys(state.userDefineInfo.fieldData)
    const newPolicy = {}
    for (const key of keys) {
      newPolicy[key] = policy[key]
    }
    state.userDefineInfo.fieldData = newPolicy
  },
  /* 원본 데이터를 복사한다. */
  setOrgSignatureUsrDefList (state) {
    state.orgSignatureUsrDefList = _.cloneDeep(state.signatureUsrDefList)
  },
  /* 사용자정의 정보를 초기화한다. */
  initUserDefineInfo (state) {
    state.userDefineInfo.fieldData = {
      signtr_opt_use_yn: 1, // 사용여부
      signtr_cate: 0, // 사용자 정의 0 / 스노트 1
      signtr_type: 0, // 유형 없음: 0, 수동설정: 1, 고급설정: 2, snort시그니처: 3
      signtr_prtc: 3, // 프로토콜 IP: 0, ICMP: 1, TCP: 2, UDP: 3
      signtr_msg: '', // 정책 이름
      signtr_risk: 1, // 위험도 하: 1, 중: 2, 상: 3
      signtr_effect: 1, // 성능 영향도 하: 1, 중: 2, 상: 3
      signtr_ckc_id: 0,
      signtr_threat_id: 1035,
      signtr_kr_desc: '',
      signtr_en_desc: '',
      signtr_jp_desc: '',
      signtr_ptrn: '', // 패턴
      signtr_opt_action: 0, // 대응 탐지: 0, 패킷 차단: 1, IP 주소 차단: 2, 패킷 차단/Reset: 3, IP 주소 차단/Reset: 4
      signtr_opt_block_key: 5,
      signtr_opt_block_tm: 180, // 차단 시간 ( - default:180 - minimum: 10 - maximum: 3600 or 0)
      signtr_opt_log_use_yn: 1,
      signtr_opt_dump_use_yn: 0,
      signtr_opt_mail_use_yn: 0,
      signtr_opt_alert_use_yn: 0,
      signtr_opt_msg: '',
      signtr_port_port_src_port: 'any', // 출발지 포트
      signtr_port_port_dst_port: 'any', // 목적지 포트
      signtr_opt_direction: 0, // 방향
      usr_def_signtr_obj: [],
      signtr_src_addr_obj: [
        {
          addr_obj_id: 1, // 주소 객체 아이디
          addr_obj_uname: 'ANY' // 이름
        }
      ],
      // dst_addr_obj: [
      signtr_dst_addr_obj: [
        {
          addr_obj_id: 1,
          addr_obj_uname: 'ANY'
        }
      ]
    }
  }
}

export const actions = {
  /**
   * 시그니처 > 필터 > 카테고리 목록을 조회한다.
   */
  async getSignatureCategory ({rootState, commit}, {loading = true}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/categories` : `${cmApiPrefix}/adsprf/signature/categories`
      const {code, result} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        commit('setSignatureCategory', result)
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 사용자 정의 정책 수정 시 대상 정책 ID에 해당하는 데이터를 조회한다.
   */
  async getDetailSignatureUsrDef ({rootState, commit}, {id, policyId = '', rowData, loading = true}) {
    const res = {code: 'ok'}
    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices/${policyId}/detail` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices/${policyId}/detail`
      const {code, result} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        // Table 상의 Data를 적용.
        commit('setDetailSignatureUsrDef', new SignatureData(_.assignIn(result, rowData)).get())
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 사용자 정의 목록을 리턴한다.
   */
  async getSignatureUsrDefList ({rootState, commit}, {id, loading = true}) {
    const res = { code: 'ok' }
    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices`
      const {code, result} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        if (modelType === 'ips') commit('initSignatureUsrDefList', {signtr_column_name: result.ngips_signtr_column_name, signtr_list: result.ngips_signtr_list})
        if (modelType === 'ads') commit('initSignatureUsrDefList', {signtr_column_name: result.ads_ips_signtr_column_name, signtr_list: result.ads_ips_signtr_list})
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 사용자 정의 정책을 설정한다.
   */
  async setSignatureUsrDef ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = { code: 'ok' }
    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices`
      params.items = _.map(params.items, o => new PolicyData(o, modelType).fromAddForm())
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        if (result.msg) res.reason = result.msg
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 사용자 정의 정책을 모두 설정한다.
   * params : edit_item: 변경할 컬럼 키
   *          edit_item_value: 변경할 컬럼의 값
   *          edit_item_list: 전체 적용할 리스트 (default: [] > 빈 배열일 경우 리스트 전체적용함)
   */
  async setAllSignatureUsrDef ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices/all` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices/all`
      const paramData = new PolicyAllForm(params, modelType)
      const {code, result} = await this.$axios.$put(url, paramData, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책에 적용된 예외 호스트 정보를 조회한다.
   */
  async getExceptHostDatas ({rootState, commit}, {id, policyId, loading = true, isNotAlert = true}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices/${policyId}/exception-hosts` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices/${policyId}/exception-hosts`
      const {code, result} = await this.$axios.$get(url, {loading, isNotAlert})

      if (code === 'ok') {
        res.result = new ExceptHostGetForm(result)
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책에 적용된 예외 호스트 정보를 수정한다.
   */
  async setExceptHostDatas ({rootState, commit, dispatch}, {params, loading = true, successAlert = true}) {
    const res = { code: 'ok' }
    try {
      const profileId = params.prf_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${profileId}/user-polices/exception-hosts` : `${cmApiPrefix}/adsprf/signature/profiles/${profileId}/user-polices/exception-hosts`
      const paramData = new ExceptHostAddForm(params, modelType).formApiParam()
      const {code, result} = await this.$axios.$put(url, paramData, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        if (result.length > 0) {
          commit('setHostItems', result)
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 사용자 정의 시그니처 데이터를 추가한다.
   */
  async addSignaturesData ({rootState, commit, dispatch}, {id, param, loading = true, successAlert = true} = {}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices`
      const paramData = new SignatureData(param, modelType).formApiParam()
      const {code, result} = await this.$axios.$post(url, paramData, { loading, successAlert })

      if (code === 'ok') {
        res.result = result
        commit('addSignatureItem', result)
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 사용자 정의 시그니처 상세 정책을 수정한다.
   */
  async editSignaturesData ({rootState, commit, dispatch}, {id, param, loading = true, policyId, successAlert = true} = {}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices/${policyId}` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices/${policyId}`
      const paramData = new SignatureData(param, modelType).formApiParam()
      const {code, result} = await this.$axios.$put(url, paramData, {
        loading,
        successAlert
      })

      if (code === 'ok') {
        res.result = _.map(result, o => new PolicyData(o).get())
        commit('setSignatureItem', new PolicyData(result[0]).get())
        commit('setOrgSignatureUsrDefList')
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * 사용자 정의 시그니처 데이터를 삭제한다.
   */
  async delSignaturesData ({rootState, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    let res = {code: 'ok'}

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/user-polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/user-polices`
      const {code, result} = await this.$axios.$delete(url, {
        data: (modelType === 'ips') ? {ngips_signtr_list: params} : {ads_ips_signtr_list: params},
        loading,
        successAlert
      })

      if (code !== 'ok') {
        if (code === 'pok') {
          res = {code: 'pok', reason: result.errors}
        } else {
          res = {code: 'nok', reason: [result.msg]}
        }
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }

    return res
  },
  /**
   * 사용자 정의 스노트 데이터를 추가한다.
   */
  async addSnortData ({rootState, commit, dispatch}, {id, param, loading = true, successAlert = true} = {}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/snorts` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/snorts`

      if (modelType === 'ips') param.ngips_profile_list = param.profile_list
      if (modelType === 'ads') param.ads_ips_profile_list = param.profile_list
      delete param.profile_list

      const {code, result} = await this.$axios.$post(url, param, {
        loading,
        successAlert
      })

      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 사용자 정의 스노트 상세 정책을 수정한다.
   */
  async editSnortData ({rootState, commit, dispatch}, {id, param, loading = true, policyId, successAlert = true} = {}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/snorts/${policyId}` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/snorts/${policyId}`
      const paramData = new SignatureData(param, modelType).formApiParam()
      const {code, result} = await this.$axios.$put(url, paramData, {
        loading,
        successAlert
      })

      if (code === 'ok') {
        res.result = new PolicyData(result).get()
        commit('setSignatureItem', new PolicyData(result).get())
        commit('setOrgSignatureUsrDefList')
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * 전달된 URL에 해당하는 파일 다운로드를 요청한다.
   */
  async getExcelDownload ({rootState, commit}, {id}) {
    const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
    const url = (modelType === 'ips') ? `${smApiPrefix}/signature/user-polices/${id}/file` : `${cmApiPrefix}/adsprf/signature/user-polices/${id}/file`
    const result = await this.$axios.$file(url, {responseType: 'blob'})
    return result
  },
  /**
   * 특정 정책을 가지고 있는 프로파일 리스트 조회
   */
  async getUserDefProfileList ({rootState, commit}, {signtrId, loading = true}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/search-profiles/user-polices/${signtrId}` : `${cmApiPrefix}/adsprf/signature/search-profiles/user-polices/${signtrId}`
      const {code, result} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        res.result = new ProfileData(result).get()
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 사용자 정의 정책을 다른 프로파일에 적용한다.
   */
  async setOtherProfiles ({rootState, state, commit, dispatch}, {signtrId, params, loading = true, successAlert = true}) {
    const res = { code: 'ok' }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/apply-profiles/user-polices/${signtrId}` : `${cmApiPrefix}/adsprf/signature/apply-profiles/user-polices/${signtrId}`
      const paramData = new OtherProfileApplyForm(params, modelType)
      const {code, result} = await this.$axios.$post(url, paramData, {loading, successAlert, alertMsg: i18n.t('msg.updateApply')})

      if (code === 'ok') {
        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
